<script setup lang="ts">
import Modal from '@/components/Modal.vue'
import { ref, onMounted, computed } from 'vue'
import type { StorefrontProduct } from '@/services/storefront'
import { loadVariant } from '@/services/storefront'
import StarterKitContentsListItem from '@/components/StarterKitContentsListItem.vue'

const props = defineProps<{
  title: string
  config: {
    productVariantId: string
    quantity: number
    frequency: number
    initialDelay?: number
  }[]
}>()

const productData = ref<{ [key: string]: StorefrontProduct }>({})

const load = async () => {
  props.config.forEach(async (item) => {
    const variant = await loadVariant(item.productVariantId)
    productData.value[item.productVariantId] = variant
  })
}

onMounted(load)

const firstOrderOnly = computed(() => {
  return props.config.filter((item) => item.frequency === -1)
})

const regularOrders = computed(() => {
  return props.config.filter(
    (item) => item.frequency > 0 || item.frequency === -2,
  )
})

const showing = ref(true)
</script>

<template>
  <Modal :title="title" v-if="showing" @close="showing = false">
    <div class="Modal__SimpleContentContainer">
      <div class="Product__StarterKitContents Product__WhyBuyBower--light">
        <h5>In your regular orders</h5>
        <div v-for="item in regularOrders" :key="item.productVariantId">
          <template v-if="productData[item.productVariantId]">
            <StarterKitContentsListItem
              :item="item"
              :productData="productData[item.productVariantId]"
            />
          </template>
        </div>
        <div class="Modal__Panel" v-if="firstOrderOnly.length > 0">
          <h5>In your first order only</h5>
          <div v-for="item in firstOrderOnly" :key="item.productVariantId">
            <template v-if="productData[item.productVariantId]">
              <StarterKitContentsListItem
                :item="item"
                :productData="productData[item.productVariantId]"
              />
            </template>
          </div>
        </div>
      </div>
    </div>
  </Modal>
</template>

<style>
.Product__StarterKitContents {
  & p {
    margin-bottom: 0;
  }
}
</style>
